import React, { useEffect } from 'react';
import { Modal, Form, Select, Checkbox } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLangField } from '../../../../../../hooks/useLangField';
import styles from './ModalEvent.module.scss';

export const ModalEvent = ({ mode, open, onCancel, onSubmit, initialValues }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const getLangField = useLangField();
  const organizationTypes = useSelector((state) => state.dictionaries.organizationTypes);
  const { chapters, categories, subCategories } = useSelector((state) => {
    return {
      chapters: state.eduEventRegistry.dictionaries.chapters,
      categories: state.eduEventRegistry.dictionaries.categories,
      subCategories: state.eduEventRegistry.dictionaries.subCategories,
    };
  });

  useEffect(() => {
    if (open) {
      form.setFieldsValue(
        initialValues !== null && initialValues !== undefined
          ? {
              ...initialValues,
              orgTypeId: initialValues.orgType && initialValues.orgType.id,
              chapterId: initialValues.chapter && initialValues.chapter.id,
              categoryId: initialValues.category && initialValues.category.id,
              subCategoryId: initialValues.subCategory && initialValues.subCategory.id,
            }
          : { orgTypeId: undefined, code: '', name: '' }
      );
    }
  }, [open, initialValues, form]);

  const handleOk = async () => {
    const values = await form.validateFields();
    if (initialValues && initialValues.id) values.id = initialValues.id;
    onSubmit({ mode, values });
    form.resetFields();
    onCancel();
  };
  console.log(initialValues);

  return (
    <Modal
      title={
        mode === 'create'
          ? t('governmentServiceEducation.modalTitleAddNewEvent')
          : t('governmentServiceEducation.modalTitleEditEvent')
      }
      open={open}
      onOk={handleOk}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      okText={
        mode === 'create'
          ? t('governmentServiceEducation.create')
          : t('governmentServiceEducation.save')
      }
      cancelText={t('governmentServiceEducation.cancel')}
      destroyOnClose
      width={560}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('governmentServiceEducation.chapter')}
          name="chapterId"
          rules={[{ required: true, message: t('error.requiredField') }]}
        >
          <Select
            placeholder={t('governmentServiceEducation.chooseChapter')}
            options={
              chapters &&
              chapters.map((item) => ({
                value: item.id,
                label: item.name,
              }))
            }
          />
        </Form.Item>

        <Form.Item
          label={t('governmentServiceEducation.category')}
          name="categoryId"
          rules={[{ required: true, message: t('error.requiredField') }]}
        >
          <Select
            placeholder={t('governmentServiceEducation.chooseCategory')}
            options={
              categories &&
              categories.map((item) => ({
                value: item.id,
                label: item.name,
              }))
            }
          />
        </Form.Item>

        <Form.Item
          label={t('governmentServiceEducation.subCategory')}
          name="subCategoryId"
          rules={[{ required: true, message: t('error.requiredField') }]}
        >
          <Select
            placeholder={t('governmentServiceEducation.chooseSubCategory')}
            options={
              subCategories &&
              subCategories.map((item) => ({
                value: item.id,
                label: item.name,
              }))
            }
          />
        </Form.Item>
        <Form.Item
          label={t('governmentServiceEducation.organizationType')}
          name="orgTypeId"
          rules={[{ required: true, message: t('error.requiredField') }]}
        >
          <Select
            placeholder={t('governmentServiceEducation.chooseOrganizationType')}
            options={organizationTypes.map((type) => ({
              value: type.id,
              label: getLangField(type, 'name'),
            }))}
          />
        </Form.Item>
        <div className={styles.checkboxes}>
          <div>
            <Form.Item name="isAttachmentRequired" valuePropName="checked">
              <Checkbox>{t('governmentServiceEducation.isAttachmentRequired')}</Checkbox>
            </Form.Item>
            <Form.Item name="isServiceCodeRequired" valuePropName="checked">
              <Checkbox>{t('governmentServiceEducation.isServiceCodeRequired')}</Checkbox>
            </Form.Item>
          </div>
          <div>
            <Form.Item name="isUrlRequired" valuePropName="checked">
              <Checkbox>{t('governmentServiceEducation.isUrlRequired')}</Checkbox>
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
